import { z } from "zod"
import { CampaignLogKindEnum } from "./commonTypes"

export const FilterOutReason = {
  notLaunched: "notLaunched",
  notActive: "notActive",
  finished: "finished",
  archived: "archived",
  optedOut: "optedOut",
  emailBounced: "emailBounced",
  emailRejected: "emailRejected",
  ongoingConversation: "ongoingConversation",
  recentConversation: "recentConversation",
  noWhatsappNumber: "noWhatsappNumber",
  noWhatsappTemplates: "noWhatsappTemplates",
  noEmail: "noEmail",
  noEmailTemplates: "noEmailTemplates",
  noChannel: "noChannel",
  noCredits: "noCredits",
  goalFrequency: "goalFrequency",
  noEligibleGoals: "noEligibleGoals",
} as const

export type FilterOutReason = keyof typeof FilterOutReason

export const LaunchLogSchema = z.object({})

export const FilterOutLogSchema = z.object({
  filterName: z.string(),
  reasons: z.array(z.enum(Object.values(FilterOutReason) as [string, ...string[]])),
})

export const TriggerDelayedLogSchema = z.object({
  reason: z.string().nullish(),
  originalDelayInHours: z.number().nullish(),
  newDelayInHours: z.number(),
})

export const WorkflowActionFailedLogSchema = z.object({
  error: z.string(),
  metadata: z
    .record(z.string(), z.union([z.string(), z.number(), z.boolean(), z.null(), z.undefined()]))
    .nullish(),
})

export const ConditionsNotMetLogSchema = z.object({
  eventType: z.string(),
  metConditions: z.array(
    z.object({
      field: z.string(),
      operator: z.string(),
      value: z.string().nullish(),
      config: z.record(z.string(), z.any()).nullish(),
    }),
  ),
  notMetConditions: z.array(
    z.object({
      field: z.string(),
      operator: z.string(),
      value: z.string().nullish(),
      config: z.record(z.string(), z.any()).nullish(),
    }),
  ),
})

export const WorkflowExecutionFailedLogSchema = z.object({
  errorMessage: z.string(),
})

export const CampaignLogSchema = z.discriminatedUnion("kind", [
  z.object({
    kind: z.literal(CampaignLogKindEnum.Launch),
    log: LaunchLogSchema,
  }),
  z.object({
    kind: z.literal(CampaignLogKindEnum.FilterOut),
    log: FilterOutLogSchema,
  }),
  z.object({
    kind: z.literal(CampaignLogKindEnum.Outreach),
  }),
  z.object({
    kind: z.literal(CampaignLogKindEnum.Trigger),
  }),
  z.object({
    kind: z.literal(CampaignLogKindEnum.TriggerResumed),
  }),
  z.object({
    kind: z.literal(CampaignLogKindEnum.TriggerDelayed),
    log: TriggerDelayedLogSchema,
  }),
  z.object({
    kind: z.literal(CampaignLogKindEnum.WorkflowActionFailed),
    log: WorkflowActionFailedLogSchema,
  }),
  z.object({
    kind: z.literal(CampaignLogKindEnum.ConditionsNotMet),
    log: ConditionsNotMetLogSchema,
  }),
  z.object({
    kind: z.literal(CampaignLogKindEnum.WorkflowExecutionSucceeded),
  }),
  z.object({
    kind: z.literal(CampaignLogKindEnum.WorkflowExecutionFailed),
    log: WorkflowExecutionFailedLogSchema,
  }),
  z.object({
    kind: z.literal(CampaignLogKindEnum.ConversationAchieved),
  }),
])
